import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REACT_APP_API_URL, camelizeResponse, getCookie } from 'shared';
const baseQuery = fetchBaseQuery({
    baseUrl: REACT_APP_API_URL,
    prepareHeaders: async (headers, { getState }) => {
        const hyperDxCookie = getCookie('__rum_sid');
        const testAutomationCookie = getCookie('TestAutomation');
        headers.set('Hyperdx-Session-Info', hyperDxCookie);
        headers.set('X-Client-Page', window.location.href);
        if (testAutomationCookie) {
            headers.set('TestAutomation', testAutomationCookie);
        }
        const state = getState();
        const receiptToken = state?.root?.creditPortal?.receipt?.token;
        receiptToken &&
            headers.set('Authorization', process.env.NODE_ENV === 'test' ? '' : receiptToken);
    },
});
const baseQueryWithCamelize = camelizeResponse(baseQuery);
export const api = createApi({
    reducerPath: 'consumerPortalApi',
    baseQuery: baseQueryWithCamelize,
    endpoints: (build) => ({
        //this endpoint is manually added to add the application/pdf header, but uses the codegen types
        getConsumerV2ReceiptsReceiptUuidPDF: build.query({
            query: (queryArg) => ({
                url: `/consumer/v2/receipts/${queryArg.receiptUuid}`,
                headers: {
                    accept: 'application/pdf',
                },
                responseHandler: async (response) => {
                    const blob = await response.blob();
                    const pdfWindowUrl = URL.createObjectURL(blob);
                    return { pdfWindowUrl };
                },
            }),
        }),
        postConsumerV2ReceiptsReceiptUuidIdentityVerification: build.mutation({
            query: (queryArg) => ({
                url: `/consumer/v2/receipts/${queryArg.receiptUuid}/identity_verification`,
                method: 'POST',
            }),
        }),
        postConsumerV2ReceiptsReceiptUuidIdentityVerificationComplete: build.mutation({
            query: (queryArg) => ({
                url: `/consumer/v2/receipts/${queryArg.receiptUuid}/identity_verification/complete`,
                method: 'POST',
                body: queryArg.body,
            }),
        }),
    }),
    keepUnusedDataFor: 0,
});
export const { useLazyGetConsumerV2ReceiptsReceiptUuidPDFQuery, usePostConsumerV2ReceiptsReceiptUuidIdentityVerificationMutation, usePostConsumerV2ReceiptsReceiptUuidIdentityVerificationCompleteMutation, } = api;
